// extracted by mini-css-extract-plugin
module.exports = {"rotation":"TonalitaDetailTemplate_rotation__gNvj4"};